declare namespace $ {

	type $giper_baza_link_chip__link_giper_baza_unit_sand_dump_1 = $mol_type_enforce<
		ReturnType< $giper_baza_unit_sand_dump['value'] >
		,
		ReturnType< $giper_baza_link_chip['link'] >
	>
	type $mol_dump_value__value_giper_baza_unit_sand_dump_2 = $mol_type_enforce<
		ReturnType< $giper_baza_unit_sand_dump['value'] >
		,
		ReturnType< $mol_dump_value['value'] >
	>
	export class $giper_baza_unit_sand_dump extends $mol_view {
		value( ): any
		land( ): $giper_baza_land
		sand( ): $giper_baza_unit_sand
		Ref( ): $giper_baza_link_chip
		Other( ): $mol_dump_value
	}
	
}

//# sourceMappingURL=dump.view.tree.d.ts.map